module.exports = __webpack_public_path__ + "img/zhongxun-radio-icon.ca1d01a3.png";